import { QMenuButton } from '@qualio/ui-components';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { PageOrientation } from '../../../../../api/model/document';
import { DocumentOverviewContext } from '../../Context';
import { useUpdateOrientation } from './useUpdateOrientation';

export const ChangeOrientationButton = () => {
  const { t } = useTranslation();
  const { qualioDocument } = useContext(DocumentOverviewContext);

  const { mutate: updateOrientation, isLoading: isUpdating } =
    useUpdateOrientation();

  const handleUpdateOrientation = async (orientation: PageOrientation) => {
    updateOrientation({ documentId: qualioDocument.id, orientation });
  };

  const getItems = () => {
    if (qualioDocument.orientation === PageOrientation.Portrait) {
      return [{ label: t('buttons.wide'), id: PageOrientation.Landscape }];
    }
    return [{ label: t('buttons.standard'), id: PageOrientation.Portrait }];
  };

  return (
    <QMenuButton
      isDisabled={isUpdating}
      variant="ghost"
      items={getItems()}
      onItemClick={(option) =>
        option && handleUpdateOrientation(option.id as PageOrientation)
      }
      buttonLabel={
        qualioDocument.orientation === PageOrientation.Portrait
          ? t('buttons.standard')
          : t('buttons.wide')
      }
      data-cy="orientation-button"
    />
  );
};
